import { SIZE_FULL } from '@/lib/gridElements/size';
import { X } from '@/lib/socialProfile';

import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: {
            likes: 'chart.best_time_to_post.likes_more',
            replies: 'chart.best_time_to_post.replies_more',
            reposts: 'chart.best_time_to_post.reposts_more',
            quotes: 'chart.best_time_to_post.quotes_more',
            engagements: 'chart.best_time_to_post.engagement_more',
            impressions: 'chart.best_time_to_post.impressions_more'
        },
        value: {
            likes: 'chart.best_time_to_post.likes_less',
            replies: 'chart.best_time_to_post.replies_less',
            reposts: 'chart.best_time_to_post.reposts_less',
            quotes: 'chart.best_time_to_post.quotes_less',
            engagements: 'chart.best_time_to_post.engagement_less',
            impressions: 'chart.best_time_to_post.impressions_less'
        }
    },
    noTableView: true,
    csv: true,
    id: 'best_time_to_post',
    social: X,
    color: {
        value: 'white'
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            likes: 'chart.x.best_time_to_post_likes_tooltip_chart',
            replies: 'chart.x.best_time_to_post_replies_tooltip_chart',
            reposts: 'chart.x.best_time_to_post_reposts_tooltip_chart',
            quotes: 'chart.x.best_time_to_post_quotes_tooltip_chart',
            engagements: 'chart.x.best_time_to_post_engagements_tooltip_chart',
            impressions: 'chart.x.best_time_to_post_impressions_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    legendHighlightValueTranslation: {
        filtersToken: {
            likes: 'chart.x.best_time_to_post_likes_legend_highlight',
            replies: 'chart.x.best_time_to_post_replies_legend_highlight',
            reposts: 'chart.x.best_time_to_post_reposts_legend_highlight',
            quotes: 'chart.x.best_time_to_post_quotes_legend_highlight',
            engagements: 'chart.x.best_time_to_post_engagements_legend_highlight',
            impressions: 'chart.x.best_time_to_post_impressions_legend_highlight'
        },
        values: ['date', 'day']
    },
    defaultFilter: 'engagements',
    filters: {
        likes: {
            title: 'chart.x.best_time_to_post_likes',
            menu: 'chart.x.best_time_to_post_filter_likes'
        },
        replies: {
            title: 'chart.x.best_time_to_post_replies',
            menu: 'chart.x.best_time_to_post_filter_replies'
        },
        reposts: {
            title: 'chart.x.best_time_to_post_reposts',
            menu: 'chart.x.best_time_to_post_filter_reposts'
        },
        quotes: {
            title: 'chart.x.best_time_to_post_quotes',
            menu: 'chart.x.best_time_to_post_filter_quotes'
        },
        engagements: {
            title: 'chart.x.best_time_to_post_engagements',
            menu: 'chart.x.best_time_to_post_filter_engagements'
        },
        impressions: {
            title: 'chart.x.best_time_to_post_impressions',
            menu: 'chart.x.best_time_to_post_filter_impressions'
        }
    },
    tooltip: 'chart.x.tooltip_best_time_to_post',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    element: HeatMapChart
};
